<template>
  <div class="md:py-12 lg:py-12 py-6 relative">
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/elli.svg"
        alt="ellipsis"
        class=""
      />
    </div>
    <div class="absolute -bottom-1/4 left-0 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/open-posi-tri.svg"
        alt="ellipsis"
        class=""
      />
    </div>
    <div class="w-full mx-auto relative">
      <div class="absolute top-0 right-10 md:block lg:block hidden">
        <img
          src="../../../assets/images/bg-des/elli.svg"
          alt="ellipsis"
          class=""
        />
      </div>

      <p class="title-semibold fsize36-24px">Open Positions</p>
      <p class="subtitle lh32px md:pt-6 lg:pt-6 pt-4 sm-fsize13 sm-lh26">
        We are always on the lookout for committed and talented professionals
        who would like to join our team. If you are interested in specific
        opportunities or have a plan for us to consider, please send your resume
        to
        <a href="mailto:careers@caregiversaathi.co.in"
          >careers@caregiversaathi.co.in</a
        >
        We will get in touch!
      </p>
      <p
        class="subtitle lh32px md:pt-6 lg:pt-6 pt-4 sm-fsize13 sm-lh26"
        v-if="!careers.length"
      >
        Currently, we do not have any specific openings. However, we are always
        on the lookout for committed and talented professionals who would like
        to join our team. If you are interested in specific opportunities or
        have a plan for us to consider, please send your resume to
        <!-- <a href="mailto:sudeshna.banerjee@caregiversaathi.co.in."
          >sudeshna.banerjee@caregiversaathi.co.in.</a
        > -->
        <a href="mailto:careers@caregiversaathi.co.in"
          >careers@caregiversaathi.co.in</a
        >
        We will get in touch!
      </p>
      <!-- <div class="md:pt-10 lg:pt-10 pt-6">
        <div
          class="
            grid
            lg:grid-cols-3
            md:grid-cols-3
            grid-cols-1
            md:gap-10
            lg:gap-10
            gap-6
          "
        >
          <div class="md:p-8 lg:p-8 p-6 bgCCEFF2 rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">Product Designer</p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Tincidunt nisl vitae vivam euismod dolor morbi vel lobortis.
                Neque porttitor massa felis, lacinia.
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="md:p-8 lg:p-8 p-6 bgEEE2FF rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">Product Designer</p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Tincidunt nisl vitae vivam euismod dolor morbi vel lobortis.
                Neque porttitor massa felis, lacinia.
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="md:p-8 lg:p-8 p-6 bgCCEFF2 rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">Product Designer</p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Tincidunt nisl vitae vivam euismod dolor morbi vel lobortis.
                Neque porttitor massa felis, lacinia.
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="md:p-8 lg:p-8 p-6 bgEEE2FF rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">Product Designer</p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Tincidunt nisl vitae vivam euismod dolor morbi vel lobortis.
                Neque porttitor massa felis, lacinia.
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="bgCCEFF2 md:block lg:block hidden p-8 rounded-2xl">
            <p class="mbr-price text-black">Product Designer</p>
            <p class="joinus-subtitle pt-1 text-black fsize24-16">Location</p>
            <p class="pt-4 mc-subtitle md:block lg:block hidden ellipsis-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt
              nisl vitae vivam euismod dolor morbi vel lobortis. Neque porttitor
              massa felis, lacinia.
            </p>
            <div class="flex justify-between items-center pt-6">
              <base-button
                outline
                type="primary"
                class="px-8 py-2 fs16700 border-2"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="bgEEE2FF md:block lg:block hidden p-8 rounded-2xl">
            <p class="mbr-price text-black">Product Designer</p>
            <p class="joinus-subtitle pt-1 text-black fsize24-16">Location</p>
            <p class="pt-4 mc-subtitle md:block lg:block hidden ellipsis-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt
              nisl vitae vivam euismod dolor morbi vel lobortis. Neque porttitor
              massa felis, lacinia.
            </p>
            <div class="flex justify-between items-center pt-6">
              <base-button
                outline
                type="primary"
                class="px-8 py-2 fs16700 border-2"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('career-details')"
              >
                Know More
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="md:pt-10 lg:pt-10 pt-6">
        <div
          class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:gap-10 lg:gap-10 gap-6"
        >
          <div
            class="md:p-8 lg:p-8 p-6 bgCCEFF2 rounded-2xl"
            v-for="(item, index) in careers"
            :key="index"
          >
            <p class="mbr-price text-black fsize20 sm-fsize18px">
              {{ item.jobRole }}
            </p>
            <p
              class="joinus-subtitle md:mt-1 lg:mt-1 -mt-2 text-black fsize18 sm-fsize16"
            >
              Location: {{ item.location }}
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 fsize16 ellipsis-3 text-7777">
                Responsibilities include:
                <br />
                <span v-html="item.responsibility"></span>
                <!-- 1. Administer Caregiver Saathi's burnout tool, analyze and
                prepare detailed reports of the same <br />
                2. Assist in content development related to psychology for
                Caregiver Saathi education<br />
                3. Conduct research on various psychological issues related to
                caregiving for handbooks prepared by the organization<br />
                4. Facilitate in developing and conducting workshops<br />
                5. Assist in social media activities, share and implement ideas
                for social media initiatives <br />
                Skills required:<br />
                English Proficiency (Written & Spoken), fluency in various
                social media platforms such as Facebook, Instagram, LinkedIn to
                name a few<br /> -->
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="md:px-8 lg:px-8 px-6 md:py-2 lg:py-2 py-1 fs16700 border-2"
                @click="handleRoute('request-form', 'work-at-cgs-as-jobs')"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('psychology-intern', item)"
              >
                Know More
              </p>
            </div>
          </div>
          <!-- <div class="md:p-8 lg:p-8 p-6 bgEEE2FF rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">
              Social Media Intern:
            </p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location: Remote
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Responsibilities will include: <br />
                1. Creating social media content and creatives as per brand
                guidelines and identifying trends and followings on social
                media<br />
                2. Posting content and maintaining our social media presence by
                keeping the audience engaged<br />
                3. Measuring and reporting performance of all social media
                campaigns and assessing against goals<br />
                4. Designing newsletters and email marketing campaigns <br />
                Skills required <br />
                Familiarity with various social media platforms, Canva, Content
                writing,Video & Audio Editing tools, Email Marketing tools,
                English Proficiency (Written & Spoken) <br />
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                @click="handleClick('social-media-intern')"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('social-media-intern')"
              >
                Know More
              </p>
            </div>
          </div> -->
          <!-- <div class="md:p-8 lg:p-8 p-6 bgCCEFF2 rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">
              IT and Operations Admin
            </p>
            <p
              class="
                joinus-subtitle
                md:mt-1
                lg:mt-1
                -mt-2
                text-black
                fsize24-16
              "
            >
              Location: Remote
            </p>
            <div class="md:block lg:block hidden">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Responsibilities will include: <br />
                1. Coordinating office admin activities and operations in a
                timely manner<br />
                2. Managing/Scheduling appointments, live sessions, webinars,
                preparing meeting agendas/minutes, phone calls, emails and other
                correspondence etc.<br />
                3. Ability to comfortably operate various apps on Social Media
                and Video conference apps like Google Meet, Zoom, Restream etc.
                and manage live sessions including webinars <br />
                4. Contributing to and gaining experience in multiple facets of
                organization development, consulting, learning, HR, business
                development, digital marketing, community building, social work,
                etc.<br />

                Note: This role demands versatility, punctuality,
                meticulousness, perseverance, resilience, creative thinking and
                the ability to manage multiple activities with quality and
                grace. <br />
                Skills required <br />
                MS-Office, Google Workspace, Social Media, Video Conferencing
                Apps, English Proficiency (Written & Spoken) <br />
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="
                  md:px-8
                  lg:px-8
                  px-6
                  md:py-2
                  lg:py-2
                  py-1
                  fs16700
                  border-2
                "
                @click="handleClick('it-and-operations-admin-intern')"
                >Apply</base-button
              >
              <p class="fs16700 text-primary cursor-pointer">Know More</p>
            </div>
          </div> -->
          <!-- <div class="md:p-8 lg:p-8 p-6 bgEEE2FF  rounded-2xl">
            <p class="mbr-price text-black fsize30-20px">
              Social Media Intern:
            </p>
            <p
              class="joinus-subtitle md:mt-1 lg:mt-1 -mt-2 text-black fsize24-16"
            >
              Location: Remote
            </p>
            <div class=" md:block lg:block hidden ">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Responsibilities will include: <br />
                1. Creating social media content and creatives as per brand
                guidelines and identifying trends and followings on social
                media<br />
                2. Posting content and maintaining our social media presence by
                keeping the audience engaged<br />
                3. Measuring and reporting performance of all social media
                campaigns and assessing against goals<br />
                4. Designing newsletters and email marketing campaigns <br />
                Skills required <br />
                Familiarity with various social media platforms, Canva, Content
                writing,Video & Audio Editing tools, Email Marketing tools,
                English Proficiency (Written & Spoken) <br />
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="md:px-8 lg:px-8 px-6 md:py-2 lg:py-2 py-1 fs16700 border-2"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('social-media-intern')"
              >
                Know More
              </p>
            </div>
          </div>
          <div
            class="md:p-8 lg:p-8 p-6 bgCCEFF2  rounded-2xl md:block lg:block hidden "
          >
            <p class="mbr-price text-black fsize30-20px">Psychology Intern</p>
            <p
              class="joinus-subtitle md:mt-1 lg:mt-1 -mt-2 text-black fsize24-16"
            >
              Location: Remote
            </p>
            <div class=" md:block lg:block hidden ">
              <p class="pt-4 mc-subtitle ellipsis-3">
                Responsibilities include:
                <br />
                1. Administer Caregiver Saathi's burnout tool, analyze and
                prepare detailed reports of the same <br />
                2. Assist in content development related to psychology for
                Caregiver Saathi education<br />
                3. Conduct research on various psychological issues related to
                caregiving for handbooks prepared by the organization<br />
                4. Facilitate in developing and conducting workshops<br />
                5. Assist in social media activities, share and implement ideas
                for social media initiatives <br />
                Skills required:<br />
                English Proficiency (Written & Spoken), fluency in various
                social media platforms such as Facebook, Instagram, LinkedIn to
                name a few<br />
              </p>
            </div>
            <div class="flex justify-between items-center md:pt-6 lg:pt-6 pt-4">
              <base-button
                outline
                type="primary"
                class="md:px-8 lg:px-8 px-6 md:py-2 lg:py-2 py-1 fs16700 border-2"
                >Apply</base-button
              >
              <p
                class="fs16700 text-primary cursor-pointer"
                @click="handleClick('psychology-intern')"
              >
                Know More
              </p>
            </div>
          </div>
          <div class="bgEEE2FF  md:block lg:block hidden p-8 rounded-2xl">
            <p class="mbr-price text-black">ABC Intern</p>
            <p class="joinus-subtitle pt-1 text-black">Location</p>
            <p class="pt-4 mc-subtitle  md:block lg:block hidden  ellipsis-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt
              nisl vitae vivam euismod dolor morbi vel lobortis. Neque porttitor
              massa felis, lacinia.
            </p>
            <div class="flex justify-between items-center pt-6">
              <base-button
                outline
                type="primary"
                class="px-8 py-2 fs16700 border-2"
                >Apply</base-button
              >
              <p class="fs16700 text-primary cursor-pointer">
                Know More
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name, careerData) {
      // this.$store.commit("cms/SET_SELECTED_CAREER", careerData);
      this.$router.push({
        name: name,
        params: {
          name: careerData.jobRole.toLowerCase().replace(/\s/g, ""),
          id: careerData._id,
        },
      });
      // this.toggleNavbar();
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },

    async getCareers() {
      await this.$store.dispatch("cms/getCareers");
      // console.log(this.careers);
    },
  },
  mounted() {
    this.getCareers();
  },
  computed: {
    ...mapState("cms", ["careers"]),
  },
};
</script>
